var GameHelpTemplate = function GameHelpTemplate(targs) {
  var line1 = '';
  var line2 = '';
  if (targs.line1) {
    line1 = targs.line1;
  }
  if (targs.line2) {
    line2 = targs.line2;
  }
  return "\n\t\t<div id=\"game-help\" class=\"game-help-triangle\">\n\t\t\t<div class=\"game-help-text\">\n\t\t\t\t<div class=\"line1\">".concat(line1, "</div>\n\t\t\t\t<div class=\"line2\" style=\"clear:both\">").concat(line2, "</div>\n\t\t\t</div>\n\t\t</div>\n  ");
  return html;
};
module.exports = GameHelpTemplate;